<app-login-header></app-login-header>
<nes-container @fadeIn data-pw="choose-account" class="nes-flex-col nes-w-full nes-mx-auto">
  <mnz-messageStoreConnector></mnz-messageStoreConnector>
  <div class="nes-w-full nes-grid nes-gap-8 nes-mt-6 md:nes-my-10 nes-grid-cols-1 md:nes-grid-cols-2 lg:nes-w-8/12">
    <app-login-tile
      data-pw="contactperson"
      type="CONTACT_PERSON"
      iconName="flex-work"
      description="LOGIN.CHOOSE_ACCOUNT.INFO_CONTACTPERSON"
    ></app-login-tile>
    <app-login-tile
      data-pw="cardholder"
      type="CARD_HOLDER"
      iconName="subscription"
      description="LOGIN.CHOOSE_ACCOUNT.INFO_CARDHOLDER"
    ></app-login-tile>
  </div>

  <div class="nes-mb-8 nes-w-full md:nes-w-8/12">
    <nes-heading [size]="'3xl'" weight="normal">
      {{ 'LOGIN.CHOOSE_ACCOUNT.NO_ACCOUNT_HEADER' | translate }}
    </nes-heading>
    <p class="nes-mt-1 nes-text-lg"> {{ 'LOGIN.CHOOSE_ACCOUNT.NO_ACCOUNT_TEXT' | translate }} </p>
    <a relay42 (click)="goToMoreInfo()" (keydown.enter)="goToMoreInfo()" class="unlink tk-link-red" tabindex="5"></a>
  </div>

  <div class="nes-mb-8">
    <nes-button data-pw="create-account-button" variant="secondary" (nesOnClick)="requestAccount()">
      <nes-text color="nes-text-blue" weight="bold" line-height="none">
        {{ "LOGIN.CHOOSE_ACCOUNT.CREATE_ACCOUNT_BUTTON_TEXT" | translate }}
      </nes-text>
    </nes-button>
  </div>

  <nes-expandable data-pw="expandable" class="nes-w-full nes-mb-10 lg:nes-w-8/12" stand-alone border-top>
    <nes-text tag="span" color="light-blue" class="nes-text-xl nes-w-full" slot="header"
      >{{ "LOGIN.CHOOSE_ACCOUNT.EXPANDABLE.HEADER" | translate }}</nes-text
    >
    <div class="nes-bg-tint-secondary nes-p-4 nes-rounded">
      <p class="nes-mb-6 nes-text-sm">{{ "LOGIN.CHOOSE_ACCOUNT.EXPANDABLE.TEXT_OPENING" | translate }}</p>

      <div class="nes-flex nes-mb-6">
        <nes-icon
          class="nes-w-12 nes-justify-center nes-items-center nes-flex-none"
          name="flex-work"
          color="blue"
        ></nes-icon>
        <p class="nes-text-sm">{{ "LOGIN.CHOOSE_ACCOUNT.EXPANDABLE.TEXT_CONTACTPERSON" | translate }}</p>
      </div>
      <div class="nes-flex nes-mb-4">
        <nes-icon
          class="nes-w-12 nes-justify-center nes-items-center nes-flex-none"
          name="subscription"
          color="blue"
        ></nes-icon>
        <p class="nes-text-sm nes-grow">{{ "LOGIN.CHOOSE_ACCOUNT.EXPANDABLE.TEXT_CARDHOLDER" | translate }}</p>
      </div>
      <p class="nes-mb-4 nes-text-sm">{{ "LOGIN.CHOOSE_ACCOUNT.EXPANDABLE.TEXT_PARAGRAPH_ONE" | translate }}</p>
      <p class="nes-mb-4 nes-text-sm">{{ "LOGIN.CHOOSE_ACCOUNT.EXPANDABLE.TEXT_PARAGRAPH_TWO" | translate }}</p>

      <div>
        <nes-heading [size]="'3xl'" weight="normal">
          {{ 'LOGIN.CHOOSE_ACCOUNT.EXPANDABLE.ZZP_INFO_HEADER' | translate }}
        </nes-heading>
        <p class="nes-mt-1 nes-text-sm">
          {{ 'LOGIN.CHOOSE_ACCOUNT.EXPANDABLE.ZZP_INFO_TEXT' | translate }}
        </p>
      </div>
    </div>
  </nes-expandable>

  <mnz-customer-requirements></mnz-customer-requirements>
</nes-container>
